import { render, staticRenderFns } from "./MaintenanceDetail.vue?vue&type=template&id=0c0674c5&scoped=true"
import script from "./MaintenanceDetail.vue?vue&type=script&lang=js"
export * from "./MaintenanceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0674c5",
  null
  
)

export default component.exports